import store from '@/store'
export default {
  // 车间型号
  className: 'Pallet',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '托盘名称不可为空'
      ]
    },
    {
      name: 'price',
      validators: [
        (val) => val >= 0 ? val < 0 : '托盘价格不可小于0'
      ]
    }
  ],
  search: [
    'name', 'price'
  ],
  hooks: {
  },
  action: {
    create: store.state.user && store.state.user.authority.allPallet.create ? {} : false,
    edit: store.state.user && store.state.user.authority.allPallet.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.allPallet.del ? {} : false
  }
}
